import { ACL_TYPE } from '@openx/types/aclType.ts';
import { AudienceOption } from '@openx/types/targeting/audience.ts';
import { usePermissionContext } from '@openx/utils/permission/context/PermissionContext.tsx';
import { isAllowedByCompiledAcl } from '@openx/utils/permission/validators.ts';
import pick from 'lodash/pick';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useCustomOptionsContext } from '../../../utils/hooks/useCustomOptionsContext.tsx';

export const useAudienceTypeOption = () => {
  const { t } = useTranslation();
  const { useIsAllowed } = usePermissionContext();
  const { isAllowed } = useIsAllowed();
  const customOptions = useCustomOptionsContext<AudienceOption>();

  const labels = useMemo(() => {
    let options: Partial<Record<AudienceOption, string>> = {};

    options[AudienceOption.INTENDED_AUDIENCE] = t('Intended Audience');
    options[AudienceOption.LIVEINTENT] = t('LiveIntent');
    options[AudienceOption.MATCHED_USERS] = t('Matched Users');
    options[AudienceOption.TRAFFIC_FILTER_EIDS] = t('Matched Users');
    options[AudienceOption.OPEN_AUDIENCES] = t('OpenXSelect');

    if (isAllowed(isAllowedByCompiledAcl(ACL_TYPE.DMP_SOURCES_READ))) {
      options[AudienceOption.DMP_SEGMENTS] = t('3rd Party DMP');
    }

    if (customOptions) {
      options = pick(options, customOptions.availableOptions);
    }

    return options;
  }, [t, isAllowed, customOptions]);

  return {
    labels,
  };
};
